import Axios from 'axios'
import {partnerUrls} from '../urls'
import router from '../../../router'
import {userUrls} from "../../AmuraService/urls";

export default {
  get_all_partners (context) {
    Axios.get(partnerUrls.getAllPartners).then(function (response) {
     
      context.commit('GET_ALL_PARTNERS', response.data)
    })
  },
  get_partners (context, publicId) {
    Axios.get(partnerUrls.getPartners + publicId).then(function (response) {
      context.commit('GET_PARTNERS', response.data)
    })
  },
  get_deleted_partners (context) {
    Axios.get(partnerUrls.getDeletedPartner).then(function (response) {
      context.commit('GET_DELETED_PARTNERS', response.data)
    })
  },
  get_partner (context, publicId) {
    Axios.get(partnerUrls.getPartner + publicId).then(function (response) {
      context.commit('GET_PARTNER', response.data)
    })
  },
  get_institution_destinations (context, publicId) {
    Axios.get(partnerUrls.getPartnerDestinations + publicId + '/view').then(function (response) {
      context.commit('PARTNER_DESTINATIONS', response.data)
    })
  },
  suspend_partner (context, data) {
    Axios.patch(partnerUrls.suspendPartner + data.public_id, data).then(function () {
      router.push({
        name: 'Partners'
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  activate_partner (context, data) {
    Axios.patch(partnerUrls.activatePartner + data.public_id, data).then(function () {
      router.push({
        name: 'Partners'
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  post_partner (context, data) {
    Axios.post(partnerUrls.postPartner, data).then(function () {
      context.dispatch('get_all_partners')
      router.push({
        name: 'Partners'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_partner (context, data) {
    Axios.post(partnerUrls.editPartner + data.public_id, data).then(function () {
      
      context.dispatch('get_all_partners')
      router.push({
        name: 'Partner',
        params: {
          partner_id: data.public_id
        }
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  delete_partner (context, publicId) {
    Axios.get(partnerUrls.deletePartner + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_PARTNERS', response.data)
      router.push({
        name: 'Module.DeletedPartners'
      })
    })
  },
  restorePartner (context, publicId) {
    Axios.get(partnerUrls.restorePartner + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PARTNERS', response.data)
      router.push({
        name: 'Module.Partners'
      })
    })
  }
}
